document.addEventListener("DOMContentLoaded", function () {
  //========================================================
  const targetClass = "pswp__counter";
  const startObserving = () => {
    const targetElement = document.querySelector(`.${targetClass}`);
    if (targetElement) {
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === "childList") {
            document.querySelector(".pagination__current--alt").innerHTML =
              mutation.target.textContent;
          }
        });
      });

      observer.observe(targetElement, {
        childList: true,
        subtree: false,
      });
    } else {
    }
  };

  const documentObserver = new MutationObserver(() => {
    startObserving();
  });

  documentObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  startObserving();

  const galleryId = ".slider-pswp-gallery";

  const pswpSlidesTotal = document.querySelectorAll(
    "a.pswp-thumbnail-anchor"
  ).length;

  const lightbox = new PhotoSwipeLightbox({
    gallery: galleryId,
    children: "a.pswp-thumbnail-anchor",
    bgOpacity: 0.65,
    pswpModule: PhotoSwipe,
    getThumbBoundsFn: (index, item) => {
      const thumb = item.el.querySelector("img");
      const rect = thumb.getBoundingClientRect();
      return { x: rect.left, y: rect.top, w: rect.width };
    },
  });
  lightbox.on("uiRegister", function () {
    // Create a container div for custom buttons
    lightbox.pswp.ui.registerElement({
      name: "custom-controls",
      order: 10, // Position in the UI
      appendTo: "wrapper",
      html: `<div class="custom-controls">
                  <button class="custom-next-btn">
                      <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">
                          <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
                      </svg>
                  </button>
                  <button class="custom-close-btn">
                      <svg width="20" height="20" viewBox="0 0 24 24">
                          <path d="M6 6L18 18M6 18L18 6"></path>
                      </svg>
                  </button>
                  
                  
                  <button class="custom-prev-btn">
                      <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18">
                          <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path>
                      </svg>
                  </button>
                  
               </div>`,
      onInit: (element) => {
        element
          .querySelector(".custom-prev-btn")
          .addEventListener("click", () => {
            document.querySelector(".pswp__button--arrow--prev").click();
          });
        element
          .querySelector(".custom-next-btn")
          .addEventListener("click", () => {
            document.querySelector(".pswp__button--arrow--next").click();
          });

        element
          .querySelector(".custom-close-btn")
          .addEventListener("click", () => {
            lightbox.pswp.close();
            document.body.classList.remove("overflow-hidden");
          });
      },
    });
  });
  lightbox.init();
});

//==========================================
function runResponsiveScript() {
  if (window.innerWidth <= 1024) {
    document.addEventListener("click", function (event) {
      var pswp__item = event.target.closest(".pswp__item");
      if (pswp__item) {
        var closeButtons = document.querySelectorAll(".custom-close-btn");

        if (closeButtons.length > 0) {
          closeButtons.forEach((button) => button.click());
        }
      }
    });
  }
}

runResponsiveScript();
